import { useMutation, useQuery } from '@tanstack/react-query';
import { AiVideoModelEnum, axiosInstance } from '../utils';

export enum FeatureType {
  AUDIO_CLONE = 'audio-clone',
  AVATAR_CLONE = 'avatar-clone',
  BROLL = 'broll',
  IMAGE_GENERATION = 'image-generation',
}

interface Payload {
  featureType: FeatureType;
  model?: string;
}

interface Response {
  eligible: boolean;
  remainingAvatars?: number;
  remainingAudios?: number;
  remainingBrolls?: number;
  remainingImages?: number;
  allowed?: number;
  isPremium?: boolean;
  noPlan?: boolean;
}

const getUserEligibility = async (payload: Payload): Promise<Response> => {
  const response = await axiosInstance.post('api/users/check-user-eligibility', payload);
  return response.data;
};

export const useGetUserEligibility = () => {
  return useMutation(getUserEligibility, { onSuccess: (data) => data });
};
